export var appVersion = process.env.VERSION || '';
export var versionFilePath = process.env.VERSION_FILE_PATH || '';
